export default {
    namespaced: true,
    state: {
		endpoint: '/state',
		item: {},
        items: [],
    },
    actions: {
		load (context, params) {
			return axios.get(context.getters.endpoint).then(response => {
				//console.log(this.$options.name, 'onSearch','response.data', response.data)
				context.commit('items', response.data)
			}, error => {
				console.log(error)
			})
		},
    }
}